import { Agency } from '../domain/agency.model'
import apiClient from '../infraestructure/apiClient'

export default {
  getAgencyList: function() {
    return apiClient.get<AgencyResponseDTO>(`/agency`)
  },
}

interface AgencyResponseDTO {
  data: Agency[]
  error?: {
    description: string
    errorCode: number
  }
  status: string
}
